jQuery(function() {
    var link = window.location.origin + window.location.pathname;

    jQuery.scrollDepth({
          minHeight: 1000,
          elements: ['.desktop .vr-related-bottom__container', '.tablet .vr-related-bottom__container', '.desktop .vr-related-bottom + div', '.tablet .vr-related-bottom + div', '.vr-mobile-body + div', '.phone .vr-related-bottom__container'],
          percentage: true,
          userTiming: false,
          pixelDepth: false,
          nonInteraction: false,
          eventHandler: function(data) {
            if(data.eventLabel === '.desktop .vr-related-bottom__container' || data.eventLabel === '.tablet .vr-related-bottom__container'){ // desktop + tablet - inner related brochures container
                ga('send', 'event', 'scroll-view-'+(isMobile && !isTablet ? 'mobile' : 'desktop'), 'fifty',  link);
            }
            else if(data.eventLabel === '.vr-mobile-body + div'){ // mobile - 1st div after brochure pages container
                ga('send', 'event', 'scroll-view-'+(isMobile && !isTablet ? 'mobile' : 'desktop'), 'fifty',  link);
            }
            else if(data.eventLabel === '.desktop .vr-related-bottom + div' || data.eventLabel === '.tablet .vr-related-bottom + div'){ //desktop + tablet 1st div after related brochure
                ga('send', 'event', 'scroll-view-'+(isMobile && !isTablet ? 'mobile' : 'desktop'), 'seventy-five',  link);
            }
            else if(data.eventLabel === '.phone .vr-related-bottom__container'){ //mobile - inner related brochures container
                ga('send', 'event', 'scroll-view-'+(isMobile && !isTablet ? 'mobile' : 'desktop'), 'seventy-five',  link);
            }
            else if(data.eventLabel === '100%'){ //equal for mobile and desktop
                ga('send', 'event', 'scroll-view-'+(isMobile && !isTablet ? 'mobile' : 'desktop'), 'hundred',  link);
            }else{
                return;
            }
        }
    });
});